import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomerCard from "./CustomerCard/CustomerCard";
import CustomerFiltersContainer from "./CustomerFilters/CustomerFiltersContainer";
import useRefreshPage from "hooks/useRefreshPage";
import SearchBarCustomersContainer from "../SearchBar/SearchBarCustomersContainer";
import { ICustomer } from "store/customers/customers-types";
import ErrorSectionContainer from "components/Common/ErrorSection/ErrorSectionContainer";
import AddNewCustomerContainer from "components/Customers/AddNewCustomer/AddNewCustomerContainer";
import "./Customers.less";
import { IAppSettings } from "store/app-settings/app-settings-types";
import FunnelIcon from "@rsuite/icons/Funnel";
import { Heading } from "rsuite";

interface ComponentProps {
    filteredCustomers: ICustomer[];
    errorMessage: string;
    appSettings: IAppSettings;
    fetchCustomers: () => void;
    setActiveCustomerById: (customerId: string) => void;
}
const Customers: React.FC<ComponentProps> = ({
    filteredCustomers,
    errorMessage,
    appSettings,
    fetchCustomers,
    setActiveCustomerById,
}: ComponentProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const containerRef = useRef<HTMLDivElement>(null);

    const title = t("customers.customersHeader");

    useEffect(() => {
        fetchCustomers();
    }, [fetchCustomers]);

    useRefreshPage(() => {
        containerRef.current?.scrollTo(0, 0);
        fetchCustomers();
    });

    if (errorMessage.length > 0) {
        return <ErrorSectionContainer />;
    }

    const onRouteHandler = (event: any, activeCustomerId: string) => {
        event.preventDefault();

        setActiveCustomerById(activeCustomerId);

        navigate(`/customers/${activeCustomerId}/details`);
    };

    const customersCards = filteredCustomers.map(
        (customer: ICustomer, index: number) => (
            <div key={String(index)}>
                <CustomerCard
                    onRoteTo={(event) => onRouteHandler(event, customer.id)}
                    customer={customer}
                    isDeliverablesEnabled={appSettings.isDeliverablesEnabled}
                />
            </div>
        )
    );

    return (
        <>
            <AddNewCustomerContainer />
            <div className="customers__container">
                <div className="customers__header">
                    <Heading style={{ marginBottom: "0.5rem" }} level={1}>
                        {title}
                    </Heading>

                    <div className="customers__search-section">
                        <SearchBarCustomersContainer />
                        <FunnelIcon
                            style={{ fontSize: "2em", margin: "0 24px" }}
                        />
                        <CustomerFiltersContainer />
                    </div>
                </div>
                <div ref={containerRef} className="cards-layout">
                    {customersCards}
                </div>
            </div>
        </>
    );
};

export default Customers;
